import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { RouteStore } from 'fluxible-router';
import SearchResult from './SearchResult';
import Spinner from '../../Spinner';
import NavigationBar from '../../NavigationBar';
import performSearchAction from '../../../action/performSearch';
import searchClickthroughAction from '../../../action/searchClickthroughAction';
import SearchStore, { SearchResultState } from '../../../stores/SearchStore';
import styles from './styles.module.styl';

class SearchPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    const { query } = this.props;

    if (query) {
      this.context.executeAction(performSearchAction, { query });
      this.context.trackEvent('submit:docs:search', { trackData: query });
    }
  }

  handleClick({id, url}) {
    const { query } = this.props;

    return () => {
      this.context.trackEvent('click:docs:search:search-result', {
        trackData: query,
        track_data2: url
      });

      this.context.executeAction(searchClickthroughAction, {
        query,
        id
      });
    };
  }

  renderResultContent() {
    const { result } = this.props;

    if (!result) {
      return <p>Please enter a query to search our documentation.</p>;
    }

    switch (result.state) {
    case SearchResultState.LOADING:
      return <Spinner />;

    case SearchResultState.LOADED:
      if (result.response.record_count === 0) {
        return <p>No results found. Would you like to try another search term?</p>;
      }

      // TODO: Show result count, pagination, etc.
      return result.response.records.page.map(page => (
        <SearchResult
          key={page.id}
          title={page.title}
          url={page.url}
          content={page.highlight.body}
          handleClick={this.handleClick(page)}
        />
      ));


    case SearchResultState.ERROR:
      return <p>There was an error loading the search result. Please try again.</p>;

    default:
      throw new Error(`Unknown search state ${result.state}`);
    }
  }

  render() {
    const { query, result } = this.props;
    const title = result ? 'Search Results' : 'Search';

    return (
      <div className="document">
        <NavigationBar currentSection="articles" query={query} />
        <div className={`${styles.searchContainer} container`}>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.searchResults}>{this.renderResultContent()}</div>
        </div>
      </div>
    );
  }
}

SearchPage.propTypes = {
  result: PropTypes.object,
  query: PropTypes.string
};

SearchPage.contextTypes = {
  getStore: PropTypes.func,
  executeAction: PropTypes.func,
  trackEvent: PropTypes.func.isRequired
};

export default connectToStores(SearchPage, [SearchStore, RouteStore], (context) => {
  const store = context.getStore(SearchStore);
  const urlStore = context.getStore(RouteStore);
  const query = urlStore.getCurrentRoute().query.q;
  const result = query ? store.getResult(query) : undefined;
  return { query, result };
});
